import { useCallback, useEffect, useState } from 'react';

import { CircleCheckIcon, CopyIcon, Tooltip } from '../../index';

export interface CopyToClipboardButtonProps {
  /** The text */
  children?: React.ReactNode;
  /** The tooltip text */
  tooltipText?: string;
  /** The text to copy to the clipboard */
  textToCopy: string;
  /** The icon to use */
  copyIcon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
}

const iconClass = 'size-4 shink-0 hidden group-hover:block';

export const CopyToClipboardButton = (props: CopyToClipboardButtonProps) => {
  const { children, textToCopy, tooltipText = 'Copy', copyIcon = CopyIcon } = props;
  const [isCopied, setIsCopied] = useState(false);

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);
    },
    [textToCopy]
  );

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 5000);
    }
  }, [isCopied]);

  return (
    <div className="group flex items-center">
      {children}
      <Tooltip
        data-testid="tooltip"
        title={isCopied ? 'Copied' : tooltipText}
        placement="top"
        arrowPointAtCenter={true}
        className="ml-1 w-2"
        overlayInnerStyle={{ fontSize: '0.75rem', lineHeight: '1rem', minHeight: '1rem' }}
      >
        <span data-testid="icon-wrapper" onClick={onClick}>
          {isCopied
            ? CircleCheckIcon({
                className: iconClass,
                title: 'CircleCheckIcon',
              })
            : copyIcon({
                className: iconClass,
                title: 'CopyIcon',
              })}
        </span>
      </Tooltip>
    </div>
  );
};
export default CopyToClipboardButton;
